<template>
    <div class="layout-topbar">
        <button class="p-link layout-menu-button" @click="onMenuToggle" v-if="!sinMenu">
            <span class="pi pi-bars"></span>
        </button>
        <!-- <div class="radio-actual-mobile">Solo visible en mobile</div> -->
        <div v-if="pdvActual && pdvActual.id" class="tituloPDV">
            CONTROL DE CONSUMO: <strong>{{ pdvActual.nombre }}</strong>
        </div>
        <div class="layout-topbar-icons">
            <div class="containerButton">
                <Menu ref="menu" :model="overlayMenuItems" :popup="true" />
                <Menu ref="menuPDV" :model="overlayMenuItemsPDV" :popup="true" />
                <button class="p-link" @click="toggleMenu" v-if="usuarioActual && usuarioActual.id">
                    <span class="username">{{ usuarioActual.usuario }}</span> <span class="layout-topbar-icon fas fa-user"></span>
                </button>
                <button class="p-link" @click="toggleMenuPDV" v-if="pdvActual && pdvActual.id">
                    <span class="layout-topbar-icon fas fa-ellipsis-v"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['sinMenu'],
    data() {
        return {
            overlayMenuItems: [
                {
                    label: 'Cerrar sesión',
                    icon: 'pi pi-power-off',
                    command: () => {
                        this.logout()
                    },
                },
            ],
            overlayMenuItemsPDV: [
                {
                    label: 'Ver QR',
                    icon: 'fas fa-qrcode',
                    command: () => {
                        this.verQR()
                    },
                },
                {
                    label: 'Cerrar sesión',
                    icon: 'pi pi-power-off',
                    command: () => {
                        this.logout()
                    },
                },
            ],
        }
    },
    methods: {
        onMenuToggle(event) {
            this.$emit('menu-toggle', event)
        },
        toggleMenu(event) {
            this.$refs.menu.toggle(event)
        },
        toggleMenuPDV(event) {
            this.$refs.menuPDV.toggle(event)
        },
        logout: function () {
            this.$store.dispatch('auth/logout')
            this.$store.dispatch('auth/logoutPDV')
            this.$router.push('/')
        },
        verQR: function () {
            this.$emit('ver-qr')
        },
    },
    computed: {
        ...mapGetters('auth', ['usuarioActual', 'pdvActual']),
    },
}
</script>
<style lang="scss" scoped>
.containerButton {
    position: relative;

    button {
        span.username {
            margin-right: 8px;
            margin-bottom: 4px;
            display: inline-block;
        }
    }
}

button.layout-menu-button {
    float: left;
}

.radio-actual-mobile {
    display: none;
    width: calc(100% - 70px);
    float: left;
    margin-left: 8px;
    font-size: 17px;
    line-height: 22px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.p-menu.p-component.p-menu-overlay {
    top: 26px !important;
    left: -35px !important;
    width: 150px;

    .p-menuitem-link {
        text-align: right;
        display: block;
    }
    .p-menuitem-icon {
        display: inline-block;
        font-size: 16px;
        vertical-align: middle;
        margin-left: 0.5em;
    }
}

.layout-static-sidebar-inactive {
    .radio-actual-mobile {
        display: block;
        width: 65%;
    }
}

@media screen and (max-width: 40em) {
    .layout-topbar {
        padding: 1em 1em 0em 1em !important;
    }

    .username {
        display: none !important;
    }

    .radio-actual-mobile {
        display: block;
    }

    .p-menu.p-component.p-menu-overlay {
        left: auto !important;
        right: 0 !important;
    }
}

.tituloPDV {
    font-size: 22px;
    line-height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 45px);
    height: 50px;
    padding-left: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

@media screen and (max-width: 40em) {
    .tituloPDV {
        font-size: 14px;
        height: auto;
        vertical-align: middle;
    }
}
</style>